import {action, makeAutoObservable, observable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { SalePriceService } from "../../../service/SalePriceService";

class ShowEditArticleSalePriceStore {

    public salePriceId: string;
    public articleId: string;
    public value: number;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore, salePriceId: string, articleId: string, value: number) {
        this.loading = false;
        this.commonStore = commonStore;
        this.salePriceId = salePriceId;
        this.articleId = articleId;
        this.value = value;
        this.isModalOpen = false;
        makeAutoObservable(this, {
            isModalOpen: observable
        });
    }

    @action
    public openModal(): void {
        this.isModalOpen = true;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async updateArticleSalePrice() {
        const response = await SalePriceService.updateArticleSalePrice(this.salePriceId, this.articleId, this.value);
        this.commonStore.processErrors(response);
        return response.success;
    }
}

export default ShowEditArticleSalePriceStore;